import { render, staticRenderFns } from "./testHeader.vue?vue&type=template&id=46d02d18&scoped=true"
import script from "./testHeader.vue?vue&type=script&lang=js"
export * from "./testHeader.vue?vue&type=script&lang=js"
import style0 from "./testHeader.vue?vue&type=style&index=0&id=46d02d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d02d18",
  null
  
)

export default component.exports